import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, output } from '@angular/core';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DocumentoDestinatario } from '../models/documentoDestinatario.model';
import { RicevutaTrasmissioneRequest } from '../models/ricevutaTrasmissioneRequest.model';

@Component({
  selector: 'app-ricevuta-trasmissione-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Stampa Ricevuta di Trasmissione" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" >
    <div>
      <label for="destinatario">Destinatario</label>
      <div class="value">
        <p-dropdown [options]="indirizzi()" type="text" placeholder="" [(ngModel)]="destinatarioSelezionato" id="destinatario" ></p-dropdown>
      </div>
    </div>
    <div>
        <label for="numeroCopie">Numero Copie</label>
        <div class="value"><input pInputText type="text" placeholder="" [(ngModel)]="numeroCopie" id="numeroCopie"></div>
    </div>
    <div>
        <label for="numeroDistintivoCopie">Numero Distintivo delle Copie</label>
        <div class="value"><input pInputText type="text" placeholder="" [(ngModel)]="numeroDistintivoCopie" id="numeroDistintivoCopie"></div>
    </div>
    <div>
        <label for="allegati">Allegati</label>
        <div class="value"><input pInputText type="text" placeholder="" [(ngModel)]="allegati" id="allegati"></div>
    </div>
    <div>
        <label for="annessi">Annessi</label>
        <div class="value"><input pInputText type="text" placeholder="" [(ngModel)]="annessi" id="annessi"></div>
    </div>
    <div>
      <label for="note" >Note</label>
      <div class="value"><textarea pInputTextarea id="note" rows="5" cols="30" [(ngModel)]="note"></textarea></div>
    </div>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" icon="pi pi-check" label="Genera" (click)="stampaRicevuta_click()"
        [disabled]="!destinatarioSelezionato"></button>
    </p-footer>
  </p-dialog>
  `,
  styles:
    [`
  :host ::ng-deep div.p-dropdown { width: -webkit-fill-available; }
  :host ::ng-deep input.p-inputtext { width: -webkit-fill-available; }
  :host ::ng-deep textarea.p-inputtextarea { width: -webkit-fill-available; }
  `]

})
export class RicevutaTrasmissioneDialogComponent {
  visible = model.required<boolean>();
  documentId = input.required<number>();
  destinatari = input<DocumentoDestinatario[] | undefined>();

  hide = output();

  public date: Date | null = null;
  public numeroCopie = '';
  public numeroDistintivoCopie = '';
  public allegati = '';
  public annessi = '';
  public note = '';
  public destinatarioSelezionato: string | null = null;
  public ricevutaTrasmissioneRequest: RicevutaTrasmissioneRequest | null = null;
  public indirizzi = computed(() => {
    const destinatari = this.destinatari();
    if (!destinatari) return [];
    const indirizzi = this.anagraficheService.indirizzi.getAsArray()
      .filter(i => destinatari?.some(dd => dd.destinatarioId === i.indirizzoId))
      .map(destinatario => destinatario.nomeIndirizzo)

    if (indirizzi.length === 1) {
      this.destinatarioSelezionato = indirizzi[0];
    }

    return indirizzi;
  });

  private anagraficheService = inject(AnagraficheService);
  private documentiService = inject(DocumentiService);

  constructor() {
    effect(() => {
      if (this.visible()) {
        this.date = null;
        this.numeroCopie = '';
        this.numeroDistintivoCopie = '';
        this.allegati = '';
        this.annessi = '';
        this.note = '';
        this.ricevutaTrasmissioneRequest = null;
        this.destinatarioSelezionato = null;
      }
    });
  }

  hideDialog(): void {
    this.hide.emit();
  }

  stampaRicevuta_click(): void {
    this.ricevutaTrasmissioneRequest = {
      destinatario: this.destinatarioSelezionato ?? '',
      numeroCopie: this.numeroCopie,
      numeroDistintivoCopie: this.numeroDistintivoCopie,
      allegati: this.allegati,
      annessi: this.annessi,
      note: this.note
    };

    this.documentiService.scaricaRicevutaTrasmissione(this.ricevutaTrasmissioneRequest, this.documentId());
    this.hide.emit();
  }

}
